import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import { rbxAuthToken } from '../config';

Vue.use(Router);

const router = new Router({
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
});

const handleBeforeEach = (to, _, next) => {
  const token = localStorage.getItem(rbxAuthToken);

  // Handle logout
  if (to.path === '/logout') {
    localStorage.removeItem(rbxAuthToken);

    return next('/login');
  }

  // Logged in users visit login page redirect them to home
  if (to.name === 'login' && token) {
    return next('/');
  }

  // Handle login
  if (!token && to.name !== 'login') {
    const params = { name: 'login' };

    // Redirect users to previously visiting page after login
    if (to.fullPath !== '/') {
      params.query = { redirect: to.fullPath };
    }

    return next(params);
  }

  return next();
};

router.beforeEach(handleBeforeEach);

export const routerBeforeEachHandler = handleBeforeEach;
export default router;
